import { horizontalListSortingStrategy } from "@dnd-kit/sortable";
import { GripVertical } from "lucide-react";
import { Chip } from "@/components/kit";
import { SortableArea, useSortableItem } from "@/components/Sortable";
import { mergeOrder, useMenuCategories, useReorderMenuCategories } from "@/lib/menuOrder";

function SortChip({ c, active, onPick, canSort }) {
  const s = useSortableItem(c.id, !canSort);
  return (
    <span ref={s.ref} style={s.style} className="shrink-0" {...(canSort ? s.listeners : {})}>
      <Chip active={active} onClick={() => onPick(c.name)} title={canSort ? "Toque para filtrar · arraste para reordenar" : undefined} data-testid={`recipe-category-${c.name}`}>
        {canSort && <GripVertical size={12} className="opacity-50 -ml-1" />}{c.name}
      </Chip>
    </span>
  );
}

export function CategoryChips({ cats, current, onPick, canSort }) {
  const { data: all = [] } = useMenuCategories();
  const reorder = useReorderMenuCategories();
  return (
    <SortableArea items={cats} strategy={horizontalListSortingStrategy} onReorder={(rows) => reorder.mutate(mergeOrder(all, rows))}>
      {cats.map((c) => <SortChip key={c.id} c={c} active={current === c.name} onPick={onPick} canSort={canSort} />)}
    </SortableArea>
  );
}
